<template>
  <div class="banner1">
    <div>请上传轮播图，点击添加即可添加图片，推荐尺寸1200*650，可拖动排序</div>
    <draggable
      v-model="currentInfo.wxSchoolPageItemList"
      @update="datadragEndContent"
      :options="{ animation: 500 }"
    >
      <div
        class="mt20 wx-item-style"
        v-for="(item, index) in currentInfo.wxSchoolPageItemList"
        :key="index"
      >
        <el-upload
          :action="fileObj.url"
          :before-upload="beforeUpload"
          :on-success="successListUpdate"
          :headers="reqData"
          :show-file-list="false"
        >
          <img class="list-img" :src="item.picture" @click="updateImg(index)" />
        </el-upload>
        <div class="flex mt10 jc-sb">
          <el-input placeholder="跳转链接地址" v-model="item.linkUrl" />
          <el-button type="danger" @click="deleteBtn(index)"
            >删除<i class="el-icon-delete"
          /></el-button>
        </div>
      </div>
    </draggable>
    <div class="jc-center mt20">
      <el-button type="primary" @click="addBannerBtn()">添加</el-button>
    </div>
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
export default {
  mixins: [codeMixin],
  methods: {
    addBannerBtn() {
      this.currentInfo.wxSchoolPageItemList.push({
        type: this.currentInfo.type,
        linkUrl: undefined,
        picture:
          "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/16541610229014466083854.png",
      });
    },
    deleteBtn(index) {
      this.currentInfo.wxSchoolPageItemList.splice(index, 1);
    },
  },
};
</script>
<style lang="less" scoped>
.banner1 {
  /deep/ .el-upload {
    width: 100%;
    .list-img {
      width: 100%;
      object-fit: cover;
      max-height: 100px;
    }
  }
  .el-input {
    width: 250px;
  }
  .wx-item-style {
    padding: 10px;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/banner/banner1/setting.vue